import moment from 'moment';
import Swal from "sweetalert2";
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';

export default {
    name: 'Categories',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        await this.CheckLoginStatus();

        if (this.loginDetails) {
            if (!this.hasAdministratorOperationalAccessUi())
                this.logout();
        }

        this.GetInfo();
    },

    mounted() {
        const el = document.getElementById('offcanvasCategoryForm');
        if (el) {
            el.addEventListener('hidden.bs.offcanvas', this.onDrawerHidden);
        }
    },

    beforeDestroy() {
        const el = document.getElementById('offcanvasCategoryForm');
        if (el) {
            el.removeEventListener('hidden.bs.offcanvas', this.onDrawerHidden);
        }
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        },
        statsCards() {
            return [
                this.statCard('إجمالي التصنيفات', this.Statistics && this.Statistics.count, 'primary', 'ti ti-category'),
                this.statCard('التصنيفات النشطة', this.Statistics && this.Statistics.active, 'success', 'ti ti-circle-check'),
                this.statCard('التصنيفات غير النشطة', this.Statistics && this.Statistics.notActive, 'secondary', 'ti ti-circle-x'),
                this.statCard('المرتبطة بالقائمة النمطية', this.Statistics && this.Statistics.linkedCount, 'info', 'ti ti-link'),
            ];
        },
        drawerTitle() {
            return this.drawerMode === 'create'
                ? `إضافة ${this.ScreenTitleSingle}`
                : `تعديل ${this.ScreenTitleSingle}`;
        },
        drawerSubtitle() {
            return this.drawerMode === 'create'
                ? 'أدخل بيانات التصنيف بتنسيق واجهة Vuexy الحديثة.'
                : 'حدّث بيانات التصنيف من اللوحة الجانبية مباشرة.';
        },
        drawerSubmitLabel() {
            return this.drawerMode === 'create'
                ? `إضافة ${this.ScreenTitleSingle}`
                : `حفظ التعديلات`;
        },
        drawerDescription() {
            return this.drawerMode === 'create'
                ? 'سيتم تفعيل التصنيف الجديد مباشرة بعد الحفظ، ويمكنك إخفاؤه لاحقاً من قائمة الإجراءات.'
                : 'يمكنك تعديل الاسم والوصف وتصنيف الرقابة، بينما تغيير حالة العرض يتم من قائمة الإجراءات داخل الجدول.';
        },
        currentStatusText() {
            if (this.drawerMode === 'create') {
                return 'سيُفعّل مباشرة';
            }
            return this.statusLabel(this.SelectedItem ? this.SelectedItem.status : 1);
        },
        currentStatusClass() {
            return this.statusBadgeClass(this.drawerMode === 'create' ? 1 : (this.SelectedItem ? this.SelectedItem.status : 1));
        }
    },

    filters: {
        moment: function (date) {
            if (date === null) {
                return "فارغ";
            }
            return moment(date).format('DD/MM/YYYY');
        },

        momentTime: function (date) {
            if (date === null) {
                return "فارغ";
            }
            return moment(date).format('DD/MM/YYYY || HH:MM');
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            Search: '',
            FilterStatus: '',
            FilterPharmacyControl: '',

            ScreenTitle: 'تصنيفات الأصناف',
            ScreenTitleSingle: 'تصنيف',
            ScreenTitleSingleAl: 'التصنيف',

            Info: [],
            Statistics: null,

            AddDialog: false,

            SelectedItem: null,
            drawerMode: 'create',

            ruleForm: {
                Id: '',
                Name: '',
                Descriptions: '',
                PharmacyControlLevel: 0,
                Image: '',
                ImageName: '',
            },
            rules: {
                Name: this.$helper.Required(),
            },
        };
    },

    methods: {
        statusBadgeClass(status) {
            return Number(status) === 1 ? 'bg-label-success' : 'bg-label-secondary';
        },
        pharmacyControlBadgeClass(level) {
            const n = Number(level);
            if (n === 1) return 'bg-label-warning';
            if (n === 2) return 'bg-label-danger';
            if (n === 3) return 'bg-label-primary';
            return 'bg-label-secondary';
        },
        statusLabel(status) {
            return Number(status) === 1 ? 'نشط' : 'غير نشط';
        },
        descriptionText(item) {
            return item && item.descriptions ? item.descriptions : 'بدون وصف إضافي';
        },
        pharmacyControlLevelLabel(level) {
            const n = Number(level);
            if (n === 1) return 'مؤثرات عقلية';
            if (n === 2) return 'مخدرات';
            if (n === 3) return 'كلا الصلاحيتين';
            return 'عادي';
        },

        categoryAvatarText(item) {
            const name = item && item.name ? item.name.trim() : '';
            if (!name) return 'CT';

            const parts = name.split(/\s+/).filter(Boolean);
            if (parts.length === 1) {
                return parts[0].slice(0, 2).toUpperCase();
            }

            return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
        },
        categoryAvatarClass(item) {
            const n = Number(item && item.pharmacyControlLevel);
            if (n === 1) return 'bg-label-warning';
            if (n === 2) return 'bg-label-danger';
            if (n === 3) return 'bg-label-primary';
            return 'bg-label-secondary';
        },
        productsCount(item) {
            const count = Number(item && item.productsCount);
            return Number.isFinite(count) ? count : 0;
        },
        linkedCount(item) {
            const count = Number(item && item.linkedCount);
            return Number.isFinite(count) ? count : 0;
        },
        tableRowNumber(index) {
            return ((Number(this.pageNo) - 1) * Number(this.pageSize)) + index + 1;
        },
        resetFormState() {
            this.ClearForm(this.ruleForm);
            this.ruleForm.Id = '';
            this.ruleForm.Name = '';
            this.ruleForm.Descriptions = '';
            this.ruleForm.PharmacyControlLevel = 0;
            this.ruleForm.Image = '';
            this.ruleForm.ImageName = '';
        },
        clearValidationState() {
            if (this.$refs.ruleForm && this.$refs.ruleForm.clearValidate) {
                this.$refs.ruleForm.clearValidate();
            }
        },
        showDrawer() {
            const el = document.getElementById('offcanvasCategoryForm');
            if (el && window.bootstrap) {
                window.bootstrap.Offcanvas.getOrCreateInstance(el).show();
            }
        },
        hideDrawer() {
            const el = document.getElementById('offcanvasCategoryForm');
            if (el && window.bootstrap) {
                const drawer = window.bootstrap.Offcanvas.getInstance(el) || window.bootstrap.Offcanvas.getOrCreateInstance(el);
                drawer.hide();
            }
        },
        onDrawerHidden() {
            this.clearValidationState();
        },
        openCreateDrawer() {
            this.drawerMode = 'create';
            this.SelectedItem = null;
            this.resetFormState();

            this.$nextTick(() => {
                this.clearValidationState();
            });
        },
        openEditDrawer(item) {
            this.drawerMode = 'edit';
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.Descriptions = item.descriptions || '';
            this.ruleForm.PharmacyControlLevel = item.pharmacyControlLevel != null && item.pharmacyControlLevel !== '' ? Number(item.pharmacyControlLevel) : 0;

            this.$nextTick(() => {
                this.clearValidationState();
                this.showDrawer();
            });
        },
        showRequestError(title, err) {
            if (err.response && err.response.data) {
                this.$helper.ShowMessage('error', title, err.response.data);
            } else {
                this.$helper.ShowMessage('error', title, 'حدث خطأ غير متوقع');
            }
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo || this.pageNo || 1;

            if (!this.Search)
                this.$blockUI.Start();
            this.$http.GetCategories(this.pageNo, this.pageSize, this.Search, this.FilterPharmacyControl, this.FilterStatus)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                });
        },

        exportToCSV() {
            const headers = ['#', 'اسم التصنيف', 'الوصف', 'عدد الأصناف', 'عدد الأصناف النمطية', 'تصنيف الرقابة', 'الحالة', 'تاريخ الإنشاء'];
            const rows = this.Info.map((item, index) => [
                this.tableRowNumber(index),
                item.name || '',
                item.descriptions || '',
                this.productsCount(item),
                this.linkedCount(item),
                this.pharmacyControlLevelLabel(item.pharmacyControlLevel),
                this.statusLabel(item.status),
                item.createdOn ? moment(item.createdOn).format('DD/MM/YYYY') : '',
            ]);

            const csvContent = '\uFEFF' + [headers, ...rows]
                .map(r => r.map(c => `"${(c || '').toString().replace(/"/g, '""')}"`).join(','))
                .join('\n');

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', 'تصنيفات_الأصناف.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        exportToPDF() {
            window.print();
        },

        submitDrawerForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.drawerMode === 'create') {
                        this.createCategory();
                    } else {
                        this.updateCategory();
                    }
                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },
        createCategory() {
            this.ruleForm.Id = Number(0);
            this.$blockUI.Start();
            this.$http.AddCategories(this.ruleForm)
                .then(response => {
                    this.$blockUI.Stop();
                    this.hideDrawer();
                    this.GetInfo(1);
                    this.resetFormState();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    this.showRequestError('خطأ بعملية الإضافة', err);
                });
        },
        updateCategory() {
            this.ruleForm.Id = Number(this.ruleForm.Id);
            this.$blockUI.Start();
            this.$http.EditCategories(this.ruleForm)
                .then(response => {
                    this.$blockUI.Stop();
                    this.hideDrawer();
                    this.GetInfo(this.pageNo);
                    this.resetFormState();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    this.showRequestError('خطأ بعملية التعديل', err);
                });
        },

        ChangeStatus(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية تغير حالة العرض  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ChangeStatusCategories(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.showRequestError('خطأ بعملية التعديل', err);
                        });
                    return;
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteCategories(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.showRequestError('خطأ بعملية الحذف', err);
                        });
                    return;
                }
            });
        },
    }
}
